import {FileActions} from "../redux_constants/files.constant";

const InitialState = {
    readLog: {},
    selected_file: null,
}

export const filesReducer = (state = InitialState, action) => {
    switch (action.type) {
        case FileActions.INIT_READ_STATUS:
            return {
                ...state,
                readLog: action.readLog,
            }
        case FileActions.UPDATE_READ_STATUS:
            return {
                ...state,
                readLog: {...state.readLog, ...action.readLog},
            }
        case FileActions.UPDATE_SELECTED_FILE:
            return {
                ...state,
                selected_file: action.selected,
            }
        default:
            return state;
    }
}